import React, { useEffect, useState, useCallback } from "react";
import Table from "../../../components/Table/Table";
import { ReactComponent as AddItemIcon } from "../../../assets/icons/add.svg";
import ActionButton from "../../../components/Buttons/ActionButton";
import dataApi, { Dataset } from "../../../Api/data.api";
import { useHistory, useLocation } from "react-router";
import Modal from "../../../components/Modals/Modal";
import Input from "../../../components/DataEntry/Input";
import Select from "../../../components/DataEntry/Select";
import AddButton from "../../../components/Buttons/AddButton";
import Search from "../../../components/Search/Search";

// import datasets from "../../../assets/mockedData/datasets";
import Header from "../../../components/Header/Header";
import Tabs from "../../../components/Tabs/Tabs";
import data_tab_data from "../../../assets/mockedData/data_tab_data";
import TextArea from "../../../components/DataEntry/TextArea";
import { ToastContainer, toast } from "react-toastify";
import { setDatasets } from "react-chartjs-2/dist/utils";
import PrimaryButton from "../../../components/Buttons/PrimaryButton";
import OutlinedButton from "../../../components/Buttons/OutlinedButton";
import validator from "validator";
import { savePathToLocalStorage } from "../../../utils/helpers";

const Datasets = () => {
  savePathToLocalStorage();


  const history = useHistory();

  // Datasets state (REST API)
  const [datasets, setDatasets] = useState<Dataset[]>([]);
  const [datasetsTotal, setDatasetsTotal] = useState(0);
  const [datasetsPage, setDatasetsPage] = useState(0);
  const [datasetsLoading, setDatasetsLoading] = useState(false);
  const PAGE_SIZE = 50;

  // User input modal state
  const [modalOpen, setModalOpen] = useState(false);
  // Delete modal state
  const [errorModal, setErrorModal] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [object, setObject] = useState("");
  const [datasetType, setDatasetType] = useState<"Images" | "Metrics">("Images");
  const [validationErrors, setValidationErrors] = useState({
    name: "",
    object: "",
  });
  const [loading, setLoading] = useState(false);
  const [dataTabData, setDataTabData] = useState(data_tab_data);
  const [row, setRow] = useState({ name: "" });

  // User input stored in state
  const [inputValue, setInputValue] = useState("");

  //TODO: add TYPE field, and according to that field format rows in table component
  const headers = [
    {
      label: "Name",
      key: "name",
      type: "text",
    },
    {
      label: "Type",
      key: "type",
      type: "text",
    },
    {
      label: "Object",
      key: "object",
      type: "number",
    },
    {
      label: "Description",
      key: "description",
      type: "text",
    },
    {
      label: "Size",
      key: "size",
      type: "text",
    },
    {
      label: "Images",
      key: "imageCount",
      type: "text",
    },
    {
      label: "Date Created",
      key: "dateCreated",
      type: "date",
    },
  ];

  // Load datasets from REST API
  const loadDatasets = useCallback(async (page: number, search?: string) => {
    setDatasetsLoading(true);
    try {
      const result = await dataApi.getDatasets(page * PAGE_SIZE, PAGE_SIZE, { search });
      setDatasets(result.data);
      setDatasetsTotal(result.totalCount);
      setDatasetsPage(page);
    } catch (err) {
      console.error('Failed to load datasets:', err);
    } finally {
      setDatasetsLoading(false);
    }
  }, []);

  const filterDatasets = (searchValue: string) => {
    setInputValue(searchValue);
    loadDatasets(0, searchValue);
  };

  // Initial load
  useEffect(() => {
    loadDatasets(0, inputValue);
  }, []);

  const handleSubmitDataset = () => {
    if (validateFields()) {
      setLoading(true);
      dataApi.createDataset(name, datasetType, description).then((data: any) => {
        history.push(`/data/datasets/${data.id}`);
      }).catch(() => setLoading(false));
    }
  };

  const handleNewDataset = () => {
    setModalOpen(true);
  };

  const openDeleteModal = (dataset: any) => {
    setRow(dataset);
    setErrorModal(true);
    console.log(dataset);
  };

  const handleDeleteModal = (dataset) => {
    setLoading(true);
    dataApi.deleteDataset(dataset.id)
      .then(() => loadDatasets(datasetsPage, inputValue))
      .then(() => setErrorModal(false))
      .then(() => setLoading(false))
      .catch((error: any) => {
        setErrorModal(false);
        setLoading(false);
        toasti(String(error));
      });
  };

  const onClose = (info) => {
    if (info == "error") {
      setErrorModal(false);
    } else if (info == "add") {
      setModalOpen(false);
    }
  };

  const validateFields = () => {
    var formValidated = true;
    var newValidationErrors = { name: "", object: "" };

    if (validator.isEmpty(name)) {
      newValidationErrors = { ...newValidationErrors, name: "Invalid name" };
      formValidated = false;
    }
    if (validator.isEmpty(object)) {
      newValidationErrors = {
        ...newValidationErrors,
        object: "Invalid object",
      };
      formValidated = false;
    }
    setValidationErrors(newValidationErrors);
    return formValidated;
  };

  // Error message handle error that we get from promise (BE)
  const ErrorMessage = ({ error }) => <div>{error}</div>;
  const toasti = (error) => {
    toast.error(<ErrorMessage error={error} />, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  // Delete modal footer
  var footer = (
    <>
      <PrimaryButton
        className="delete-button-background-color"
        onSubmit={() => handleDeleteModal(row)}
        loading={loading}
      >
        Delete
      </PrimaryButton>
      <OutlinedButton onClick={() => onClose("error")}>Cancel</OutlinedButton>
    </>
  );

  return (
    <div>
      <Header
        title="Datasets"
        searchFunction={filterDatasets}
        mainAction={
          <AddButton
            icon={<AddItemIcon />}
            label="New dataset"
            onClick={handleNewDataset}
          />
        }
      />
      <div className="main-content-flex">
        <Tabs data={dataTabData} />
        <div className="section">
          {datasetsLoading ? (
            <div style={{ padding: "2rem", textAlign: "center", color: "#6c757d" }}>Loading...</div>
          ) : (
            <>
              <Table
                items={datasets}
                headers={headers}
                onDelete={openDeleteModal}
                to="data/datasets"
                tableName="datasets"
              />
              {/* Pagination controls */}
              {datasetsTotal > PAGE_SIZE && (
                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "1rem",
                  padding: "1rem",
                  marginTop: "1rem",
                }}>
                  <button
                    onClick={() => loadDatasets(datasetsPage - 1, inputValue)}
                    disabled={datasetsPage === 0}
                    style={{
                      padding: "0.5rem 1rem",
                      borderRadius: "4px",
                      border: "1px solid rgba(108, 117, 125, 0.5)",
                      background: datasetsPage === 0 ? "rgba(33, 40, 44, 0.5)" : "rgba(83, 189, 228, 0.2)",
                      color: datasetsPage === 0 ? "#6c757d" : "#53bde4",
                      cursor: datasetsPage === 0 ? "not-allowed" : "pointer",
                    }}
                  >
                    Previous
                  </button>
                  <span style={{ color: "#c5c5c5" }}>
                    Page {datasetsPage + 1} of {Math.ceil(datasetsTotal / PAGE_SIZE)} ({datasetsTotal} datasets)
                  </span>
                  <button
                    onClick={() => loadDatasets(datasetsPage + 1, inputValue)}
                    disabled={(datasetsPage + 1) * PAGE_SIZE >= datasetsTotal}
                    style={{
                      padding: "0.5rem 1rem",
                      borderRadius: "4px",
                      border: "1px solid rgba(108, 117, 125, 0.5)",
                      background: (datasetsPage + 1) * PAGE_SIZE >= datasetsTotal ? "rgba(33, 40, 44, 0.5)" : "rgba(83, 189, 228, 0.2)",
                      color: (datasetsPage + 1) * PAGE_SIZE >= datasetsTotal ? "#6c757d" : "#53bde4",
                      cursor: (datasetsPage + 1) * PAGE_SIZE >= datasetsTotal ? "not-allowed" : "pointer",
                    }}
                  >
                    Next
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <ToastContainer
        autoClose={5000}
        position="bottom-right"
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {/* User input modal */}
      <Modal
        visible={modalOpen}
        onClose={() => onClose("add")}
        title="Add new dataset"
        onSubmit={handleSubmitDataset}
        submitLoading={loading}
      >
        <Select
          placeholder="Select dataset type"
          value={datasetType}
          options={[
            { id: "Images", name: "Images" },
            { id: "Metrics", name: "Metrics" },
          ]}
          className="input-classic"
          onChange={(e: any) => setDatasetType(e.target.value)}
          onPressEnter={handleSubmitDataset}
        />
        <Input
          placeholder="Enter a name"
          onChange={(e: any) => setName(e.target.value)}
          status={validationErrors.name && "error"}
          className="input-classic"
          validationMessage={validationErrors.name}
          onPressEnter={handleSubmitDataset}
        />
        <Input
          placeholder="Enter object name (e.g. cookie)"
          onChange={(e: any) => setObject(e.target.value)}
          status={validationErrors.object && "error"}
          className="input-classic"
          validationMessage={validationErrors.object}
          onPressEnter={handleSubmitDataset}
        />
        <TextArea
          placeholder="Add a description"
          onChange={(e: any) => setDescription(e.target.value)}
          onPressEnter={handleSubmitDataset}
          className="textarea-classic"
          rows={2}
        />
      </Modal>

      {/* Delete modal */}
      <Modal
        title={`Delete ${row && row.name} ?`}
        subtitle={"Warning: this can't be undone"}
        desc="By deleting this dataset you will lose all images related to the dataset"
        visible={errorModal}
        footer={footer}
        onClose={() => onClose("error")}
      />
    </div>
  );
};

export default Datasets;
